/* src/app/components/controls/dialogs/sem-dialog/sem-dialog.component.css */
.wg-m2o,
.wg-m2o * {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
  box-sizing: border-box;
}
.linked-data-dialog.wg-m2o {
  padding: 0;
  min-height: 0;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #0f172a;
}
.wg-m2o__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 28px 18px 28px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.wg-m2o__header-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.wg-m2o__eyebrow {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #94a3b8;
}
.wg-m2o .dialog-title-heading.wg-m2o__title {
  margin: 0 !important;
  padding: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.4px;
  color: #0f172a;
  text-transform: none;
}
.wg-m2o__close {
  appearance: none;
  border: 0;
  background: transparent;
  color: #6b7280;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin: -4px -8px 0 12px;
  transition: background 0.15s, color 0.15s;
}
.wg-m2o__close:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.wg-m2o__panel {
  padding: 20px 28px 28px 28px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}
.wg-m2o__filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 14px;
  align-items: end;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
}
.wg-m2o .search-mto-item.wg-m2o__field {
  width: auto;
  padding: 0;
  position: relative;
  min-width: 0;
}
.wg-m2o .search-mto-item.wg-m2o__field--all {
  grid-column: span 2;
}
.wg-m2o .search-mto-item .switcher,
.wg-m2o .search-mto-item .switcher > * {
  display: block;
  width: 100%;
}
.wg-m2o label.wg-m2o__label {
  display: block;
  margin: 0 0 6px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #64748b;
}
.wg-m2o input.m2o-po-vseh-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  color: #0f172a;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.wg-m2o input.m2o-po-vseh-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.wg-m2o .control-help-m2o {
  position: absolute;
  top: 0;
  right: 0;
}
.wg-m2o__actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  grid-column: -2 / -1;
}
.wg-m2o__search-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 38px;
  padding: 0 16px;
  border: 0;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.3);
  transition: background 0.15s;
}
.wg-m2o__search-btn:hover {
  background: #1d4ed8;
}
.wg-m2o__table-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 28px 8px 28px;
  min-height: 18px;
  flex-shrink: 0;
}
.wg-m2o h2.wg-m2o__results,
.wg-m2o h2.wg-m2o__error {
  margin: 0 !important;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  text-transform: none;
  letter-spacing: 0;
}
.wg-m2o h2.wg-m2o__error {
  color: #b91c1c;
  margin-right: auto !important;
}
.wg-m2o__table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0 28px;
}
.wg-m2o table.wg-m2o__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0 0 8px 0;
}
.wg-m2o table.wg-m2o__table th,
.wg-m2o table.wg-m2o__table td {
  height: 44px;
  min-width: 0;
  padding: 0 12px;
  border: 0;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  vertical-align: middle;
  font-size: 13px;
  color: #0f172a;
  background: transparent !important;
}
.wg-m2o table.wg-m2o__table th {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 36px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #64748b;
  background: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}
.wg-m2o table.wg-m2o__table th:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.wg-m2o table.wg-m2o__table th:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.wg-m2o table.wg-m2o__table td:first-child {
  border: 0;
  border-bottom: 1px solid #eef2f7;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row {
  outline: none;
  transition: background 0.1s;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row--link,
.wg-m2o table.wg-m2o__table tr.multi-select-row {
  cursor: pointer;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row:hover td,
.wg-m2o table.wg-m2o__table tr.wg-m2o__row:focus-visible td {
  background: #f1f5f9 !important;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row--selected td {
  background: #eff6ff !important;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row--selected td:first-child {
  box-shadow: inset 3px 0 0 #2563eb;
}
.wg-m2o table.wg-m2o__table .checkbox-col {
  width: 40px;
  text-align: center;
}
.wg-m2o table.wg-m2o__table .checkbox-col input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #2563eb;
}
.wg-m2o table.wg-m2o__table .wg-m2o__action-col {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  padding-right: 4px;
}
.wg-m2o table.wg-m2o__table td.wg-m2o__action-col,
.wg-m2o table.wg-m2o__table tr td:last-of-type {
  border-bottom: 1px solid #eef2f7 !important;
}
.wg-m2o__link-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  opacity: 0;
  transform: translateX(4px);
  transition:
    opacity 0.12s,
    transform 0.12s,
    border-color 0.12s;
}
.wg-m2o table.wg-m2o__table tr.wg-m2o__row:hover .wg-m2o__link-btn,
.wg-m2o table.wg-m2o__table tr.wg-m2o__row:focus-visible .wg-m2o__link-btn,
.wg-m2o table.wg-m2o__table tr.wg-m2o__row:focus-within .wg-m2o__link-btn {
  opacity: 1;
  transform: none;
}
.wg-m2o__link-btn:hover {
  border-color: #2563eb;
  background: #eff6ff;
}
.wg-m2o .multi-select-footer.wg-m2o__multi-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin: 0;
  padding: 12px 0 16px 0;
  border-top: 1px solid #e5e7eb;
}
.wg-m2o__multi-count {
  font-size: 13px;
  color: #64748b;
}
.wg-m2o__primary-btn {
  appearance: none;
  height: 36px;
  padding: 0 18px;
  border: 0;
  border-radius: 8px;
  background: #2563eb;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s;
}
.wg-m2o__primary-btn:hover {
  background: #1d4ed8;
}
.wg-m2o__primary-btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.wg-m2o .dialog-footer.wg-m2o__paging {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 28px 16px 28px;
  border-top: 1px solid #eef2f7;
  background: #fff;
  box-shadow: 0 -10px 18px -14px rgba(15, 23, 42, 0.35);
  text-align: center !important;
  flex-shrink: 0;
  bottom: auto !important;
  left: auto;
  right: auto;
}
.wg-m2o__page,
.wg-m2o__page-nav {
  appearance: none;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.wg-m2o__page:hover,
.wg-m2o__page-nav:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.wg-m2o__page.active {
  background: #2563eb;
  color: #fff;
  font-weight: 600;
}
.dialog-loader {
  z-index: 5;
  background: rgba(255, 255, 255, 0.7);
}
/*# sourceMappingURL=sem-dialog.component.css.map */
